import React, { Component } from 'react';
import db from '../Database/Database'
import DieCounter from './DieCounter';
import RollCaption from './RollCaption';
import RollMenu from './RollMenu';
import FeedbackDialog from './FeedbackDialog';

class Roller extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showExtraDice: false,
      showRollCaption: false,
      showFeedbackDialog: false,
    };
  }

  rollCounters() {
    var result,
        diceResults = {};

    // Only roll dice counter we can see
    var counterToRoll = this.props.diceTypes;
    if (this.state.showExtraDice) {
      counterToRoll = this.props.diceTypes.concat(this.props.extraDiceTypes);
    }
    counterToRoll.forEach(diceType => {
      result = this.refs[diceType.type].roll();
      diceResults[diceType.type] = result.result;
    });

    // Only if dice were rolled
    if (Object.keys(diceResults).map(d => diceResults[d].length).filter(d=>d!==0).length > 0) {

      // Append the caption, and set roll type (after checking if we have dice to roll)
      diceResults.caption = this.refs.rollCaption.getCaption();
      diceResults.type = this.props.rollType;

      this.props.onUserRollAction.call(null, diceResults);
    }
  }

  resetCounters() {
    this.props.diceTypes.concat(this.props.extraDiceTypes).forEach( diceType => {
      // Dice may be hidden
      if (this.refs[diceType.type]) {
        this.refs[diceType.type].reset();
      }
    });
  }

  addLine() {
    this.props.onUserRollAction.call(null, {type:'LINEBREAK'})
  }

  toggleOptions() {
    this.setState({ showExtraDice: !this.state.showExtraDice });
  }
  toggleCaption() {
    this.setState({ showRollCaption: !this.state.showRollCaption });
  }
  toggleFeedback() {
    this.setState({ showFeedbackDialog: !this.state.showFeedbackDialog });
  }

  clearResults() {
    db.clearResults();
  }

  onExtraDropdown(val) {
    switch(val) {
      case 'line':
        this.addLine();
        break;
      case 'clear':
        this.clearResults();
        break;
      case 'extra':
        this.toggleOptions();
        break;
      case 'caption':
        this.toggleCaption();
        break;
      case 'feedback':
        this.toggleFeedback();
        break;
      default:
        break;
    }
  }

  render() {
    var diceTypesToShow = this.props.diceTypes;
    if (this.state.showExtraDice) {
      diceTypesToShow = this.props.diceTypes.concat(this.props.extraDiceTypes);
    }
    var feedbackDialog = null;
    if (this.state.showFeedbackDialog) {
      feedbackDialog = <FeedbackDialog onClose={this.toggleFeedback.bind(this)} />;
    }

    return (
      <div className="Roller">
        <div className="DiceContainer">
          {diceTypesToShow.map(
            die => <DieCounter key={die.type} ref={die.type} type={die.type} dieClass={die} />
          )}

          <button onClick={this.rollCounters.bind(this)}>Roll</button>
          <button className="btnSmall" onClick={this.resetCounters.bind(this)}>Reset</button>

          <RollMenu onChange={this.onExtraDropdown.bind(this)} />

          <div style={{ display: this.state.showRollCaption ? 'block': 'none'}}>
            <RollCaption ref='rollCaption' />
          </div>
        </div>
        {feedbackDialog}
      </div>
    );
  }
}

export default Roller;



// WEBPACK FOOTER //
// ./src/Roller/Roller.js